import React from "react";
import styles from "./CourtTableSkeleton.module.scss";

export const CourtTableSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className={styles.headerCell} />
        ))}
      </div>
      {Array.from({ length: 10 }).map((_, rowIdx) => (
        <div key={rowIdx} className={styles.row}>
          {Array.from({ length: 6 }).map((_, colIdx) => (
            <div key={colIdx} className={styles.cell} />
          ))}
        </div>
      ))}
    </div>
  );
};
